export enum AxiosRequestService {
  PAYMENTS = 'payments',
  RESIDENT = 'resident',
  RESIDENT_REST = 'resident_rest',
  DMS = 'dms',
  MAINTENANCE = 'maintenance',
}
